import { useAuthStore } from '@/store/authStore';

export function validateRegistrationPhone(phoneNumber: string): { isValid: boolean; message?: string } {
  const { users, registerRequests } = useAuthStore.getState();

  // Check if number is already active
  const activeUser = users.find(u => u.phoneNumber === phoneNumber);
  if (activeUser) {
    return { 
      isValid: false, 
      message: 'رقم الهاتف مسجل مسبقاً. يمكنك تسجيل الدخول مباشرة' 
    };
  }

  // Check for pending requests
  const pendingRequest = registerRequests.find(
    r => r.data.phoneNumber === phoneNumber && r.status === 'pending'
  );
  if (pendingRequest) {
    return { 
      isValid: false, 
      message: 'يوجد طلب تسجيل معلق لهذا الرقم. يرجى الانتظار حتى تتم الموافقة على طلبك' 
    };
  }

  // Check if number was rejected
  const rejectedRequest = registerRequests.find(
    r => r.data.phoneNumber === phoneNumber && r.status === 'rejected'
  );
  if (rejectedRequest) {
    return {
      isValid: true // Allow registration for rejected requests
    };
  }

  return { isValid: true };
}